import { ref } from "vue"

/**
 * 图片预览相关状态和逻辑（用于在富文本中点击图片打开预览）
 */
export function useImagePreview() {
    const showimagedialogVisible = ref(false)
    const currentImageUrl = ref("")

    // 点击处理函数 — 当点击 v-html 内的 img 标签时打开预览
    const handleClick = (event) => {
        if (event.target.tagName.toLowerCase() === "img") {
            currentImageUrl.value = event.target.src
            showimagedialogVisible.value = true
        }
    }

    return {
        showimagedialogVisible,
        currentImageUrl,
        handleClick
    }
}
